import BaseModel from "./../base/baseModel";

export default class RecebimentoParceladoItemModel extends BaseModel {
    id?: number = null;
    recebimentoParceladoId: string = null;
    percentual: number;
    diasVencimento: number;
}
